import { h } from 'preact';
import { Locations, TravelDates, TravelType } from '../../../common';
import * as appStyles from '../../../assets/global.scss';
import { Actions, actions, BookingState, connectWithStyles } from '../../../store';
import { WithStyles } from '../../../style';
import { FinText } from '../../../i18n';
import Notification, { Severity } from '../Notification/Notification';

const KAO_RENOVATION_START_DATE = '2023-07-17';
const KAO_RENOVATION_END_DATE = '2023-08-15';

interface KuusamoNotificationProps {}

interface StoreProps {
  locations: Locations[];
  travelDates: TravelDates;
  travelType: TravelType;
}

const mapStateToProps = ({ selection: { locations, travelDates, travelType } }: BookingState): StoreProps => ({
  locations,
  travelDates,
  travelType,
});

type EffectiveProps = StoreProps & WithStyles & Actions;

export const KuusamoNotification = connectWithStyles<KuusamoNotificationProps>([appStyles], {
  mapStateToProps,
  actions,
})(({ locations, travelDates, travelType }: EffectiveProps) => {
  let open = false;

  if (locationAndDateMatches(locations, travelDates, travelType)) {
    open = true;
  }

  return (
    <Notification open={open} severity={Severity.ERROR}>
      <FinText id="notification.kuusamo" />
    </Notification>
  );
});

const locationAndDateMatches = (locations: Locations[], travelDates: TravelDates, travelType) => {
  const departureInRenovationRange = locationsMatches(locations?.[0]) && dateMatches(travelDates.departureDate);
  const returnInRenovationRange =
    locationsMatches(locations?.[travelType === TravelType.MULTI_CITY ? 1 : 0]) && dateMatches(travelDates.returnDate);

  return departureInRenovationRange || returnInRenovationRange;
};

const locationsMatches = (locations: Locations) =>
  [locations?.origin?.locationCode, locations?.destination?.locationCode].includes('KAO');

const dateMatches = (date: string) => date >= KAO_RENOVATION_START_DATE && date <= KAO_RENOVATION_END_DATE;
